import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { getTinyMCEMentionsQueries } from '../../../utils/tinymce';
import { useTheme } from 'styled-components';
import { Model, TinyMCE, Toast } from 'jamespot-front-business';
import { useIntl } from 'react-intl';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

export const InputRichText = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const InputTinyMCE = commonComponentsRegistry.getLazyComponent('InputTinyMCE');
    const intl = useIntl();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const tinyMCECommonOptions = useAppSelector(TinyMCE.selectors.selectTinyMCECommonOptions);
    const models = useAppSelector(Model.selectors.selectAll);

    const onError = (message?: string) => {
        dispatch(Toast.actions.error({ label: message ?? intl.formatMessage({ id: 'GLOBAL_Error' }) }));
    };

    if (!tinyMCECommonOptions) return <></>;

    return (
        <InputTinyMCE
            commonOptions={tinyMCECommonOptions}
            mentionsQueries={getTinyMCEMentionsQueries(models, theme, onError)}
            label={props.label}
            description={props.description}
            name={props.name}
            control={props.control}
            rules={{ required: props.mandatory }}
            dataCy={props.dataCy}
            readOnly={props.readOnly}
        />
    );
};
